import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import TenableCloudSecurityMappingForm from "./TenableCloudSecurityMappingForm";
import { Alert } from "antd";

function TenableCloudSecurityCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "token",
      label: "Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
    {
      name: "message",
      type: FieldTypes.LABEL,
      value: SLOW_PROJECT_LOADING_ALERT
  }
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={TenableCloudSecurityMappingForm}
      initialValue={{ apiEndpoint: 'https://us.app.ermetic.com/api/graph' }}
    />
  );
}

export default forwardRef(TenableCloudSecurityCredentialsForm);

export const SLOW_PROJECT_LOADING_ALERT = <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
